<template>
  <v-container class="fill-height pa-0 ma-0 messaging fluid" id="messaging">
    <template>
      <v-layout row>
        <v-flex lg4 class="white">
          <v-select
            v-model="sucursalSeleccionada"
            :items="sucursalesUsuario"
            item-text="nombreSucursal"
            item-value="sucursalId"
            label="Selecciona una sucursal"
            solo
            return-object
          ></v-select>
          <div class="chat-history">
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                clearable
                prepend-icon="search"
                placeholder="Búsqueda rápida"
                v-model="search"
                @input="toUpper()"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>

              <v-menu bottom left>
                <v-btn slot="activator">
                  <v-icon>filter_list</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile avatar @click="abrirBusquedaPorFechas()">
                    <v-list-tile-avatar>
                      <v-icon>local_mall</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Productos</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile avatar @click="abrirBusquedaPorFechas()">
                    <v-list-tile-avatar>
                      <v-icon>local_play</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Conjuntos</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
            <vue-perfect-scrollbar class="chat-history--scrollbar">
              <v-divider></v-divider>
              <v-list two-line class="chat-history--list">
                <template v-for="item in filteredItems">
                  <v-divider :key="item.catalogoRowId"></v-divider>
                  <v-list-tile class="chat-list" avatar :key="item.sku">
                    <v-list-tile-avatar :color="item.codigoHtml">
                      <img
                        :src="$store.state.apiHost + item.urlFoto"
                        v-if="item.urlFoto !== null"
                      />
                      <span v-else class="white--text headline">{{
                        firstLetter(item.descripcionProducto)
                      }}</span>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        item.descripcionProducto
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ item.descripcionTalla }} |
                        {{ item.nombreColor }}</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-list-tile-action-text>
                        <b class="green--text"
                          >$ {{ formatMoney(item.precioVenta) }}</b
                        >
                      </v-list-tile-action-text>
                      <v-btn
                        depressed
                        icon
                        fab
                        dark
                        color="primary darken-4"
                        small
                        title="Agregar"
                        class="v-btn-30"
                        @click="addArticulo(item)"
                      >
                        <v-icon>play_arrow</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-list>
            </vue-perfect-scrollbar>
          </div>
        </v-flex>
        <v-flex lg8>
          <v-form ref="formVenta" :v-model="true" lazy-validation>
            <v-widget title="CARRITO DE COMPRAS" color="primary darken-4" dark>
              <div slot="widget-content">
                <v-layout row wrap>
                  <v-toolbar
                    dense
                    color="primary darken-4"
                    class="text-xs-center"
                  >
                    <v-toolbar-title class="white--text"
                      >ARTÍCULOS</v-toolbar-title
                    >
                  </v-toolbar>
                  <v-flex lg12 sm12 xs12>
                    <v-card>
                      <v-card-text class="pa-0">
                        <v-data-table
                          :headers="carritoVenta.headers"
                          :search="searchCarrito"
                          :items="carritoVenta.articulos"
                          :rows-per-page-items="[
                            5,
                            10,
                            25,
                            { text: 'Todos', value: -1 },
                          ]"
                          :pagination.sync="pagination"
                          class="elevation-1"
                          item-key="catalogoRowId"
                        >
                          <template slot="items" slot-scope="props">
                            <td>
                              <v-avatar
                                size="96"
                                :color="props.item.codigoHtml"
                                class="mt-2 mb-2"
                              >
                                <img
                                  :src="
                                    $store.state.apiHost + props.item.urlFoto
                                  "
                                  v-if="props.item.urlFoto !== null"
                                />
                                <span v-else class="white--text headline">{{
                                  firstLetter(props.item.descripcionProducto)
                                }}</span>
                              </v-avatar>
                            </td>
                            <td>{{ props.item.descripcionProducto }}</td>
                            <td>{{ props.item.descripcionTalla }}</td>
                            <td>
                              <v-icon :color="props.item.codigoHtml" medium
                                >widgets</v-icon
                              >
                              {{ props.item.nombreColor }}
                            </td>
                            <td>$ {{ formatMoney(props.item.precioVenta) }}</td>
                            <td>
                              <v-text-field
                                v-model="props.item.cantidad"
                                type="number"
                                @change="calcularSubtotal()"
                              ></v-text-field>
                            </td>
                            <td>
                              <h5 class="green--text">
                                $ {{ formatMoney(props.item.subTotalProducto) }}
                              </h5>
                            </td>
                            <td>
                              <v-btn
                                depressed
                                outline
                                icon
                                fab
                                dark
                                color="pink"
                                small
                                @click="pullArticulo(props.item.catalogoRowId)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <v-alert
                            slot="no-results"
                            :value="true"
                            color="error"
                            icon="warning"
                            outline
                            >La búsqueda para "{{ searchCarrito }}" no encontró
                            registros</v-alert
                          >
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex xs12>
                    <v-data-table
                      :headers="totales.headers"
                      :items="[]"
                      hide-actions
                      no-data-text
                      no-results-text
                      class="elevation-0 table-styling table-totales"
                    >
                      <template slot="items"></template>
                      <template slot="footer">
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>SUBTOTAL</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="totales.subtotal"
                                prefix="$"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>DESCUENTO</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12 class="mt-2">
                              <v-radio-group
                                v-model="porcentajeDescuento"
                                row
                                @change="calcularTotales()"
                              >
                                <v-radio label="%" :value="true"></v-radio>
                                <v-radio label="Monto" :value="false"></v-radio>
                              </v-radio-group>
                              <v-text-field
                                v-if="porcentajeDescuento"
                                v-model="totales.porcentajeDescuento"
                                @change="calcularTotales()"
                              ></v-text-field>
                              <v-text-field
                                v-else
                                v-model="totales.montoDescuento"
                                @change="calcularTotales()"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>SUBTOTAL CON DESCUENTO</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="totales.subTotalDescuento"
                                prefix="$"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>IVA</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="totales.iva"
                                prefix="$"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-xs-right" colspan="2">
                            <strong>TOTAL</strong>
                          </td>
                          <td class="text-xs-right">
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                v-model="totales.totalFinal"
                                prefix="$"
                                :rules="[
                                  (v) =>
                                    totales.totalFinal > 0 ||
                                    'Debe haber un monto que cobrar!',
                                ]"
                                :readonly="true"
                              ></v-text-field>
                            </v-flex>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>

                  <v-toolbar
                    dense
                    color="primary darken-4"
                    class="text-xs-center"
                  >
                    <v-toolbar-title class="white--text"
                      >CLIENTE (OPCIONAL CON VENTA ENTREGADA Y SALDO
                      LIQUIDADO)</v-toolbar-title
                    >
                  </v-toolbar>

                  <v-flex xs9>
                    <v-combobox
                      ref="comboCliente"
                      v-model="clienteCombo"
                      :items="clientes"
                      item-text="nombreCompletoCliente"
                      :loading="loadingClientes"
                      item-value="clienteId"
                      @change="setCliente"
                    ></v-combobox>
                  </v-flex>

                  <v-flex xs1>
                    <v-btn
                      color="success"
                      dark
                      fab
                      small
                      slot="activator"
                      @click="abrirDialogNuevoCliente"
                    >
                      <v-icon dark>add</v-icon>
                    </v-btn>
                    <form-cliente
                      :cliente="clienteCombo"
                      :sucursal="sucursalSeleccionada"
                      ref="dialogCliente"
                      @onClienteAdded="onClienteAdded"
                      @onClienteUpdated="onClienteUpdated"
                    ></form-cliente>
                  </v-flex>
                  <v-flex
                    xs1
                    sm1
                    md1
                    lg1
                    v-if="venta.clienteId !== null && venta.clienteId !== 0"
                  >
                    <v-btn
                      color="primary"
                      dark
                      fab
                      small
                      slot="activator"
                      @click="abrirDialogCliente"
                    >
                      <v-icon dark>refresh</v-icon>
                    </v-btn>
                  </v-flex>

                  <v-flex
                    xs1
                    sm1
                    md1
                    lg1
                    v-if="venta.clienteId !== null && venta.clienteId !== 0"
                  >
                    <v-btn
                      color="red"
                      dark
                      fab
                      small
                      slot="activator"
                      @click="clearCliente"
                    >
                      <v-icon dark>close</v-icon>
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg112>
                    <div>
                      <v-icon>phone</v-icon>
                      Celular: {{ clienteCombo.telefonoCelular }}
                    </div>
                    <div>
                      <v-icon>email</v-icon>
                      Correo: {{ clienteCombo.correoContacto }}
                    </div>
                  </v-flex>

                  <v-toolbar
                    dense
                    color="primary darken-4"
                    class="text-xs-center mt-3"
                  >
                    <v-toolbar-title class="white--text"
                      >PAGO DE VENTA</v-toolbar-title
                    >
                  </v-toolbar>

                  <v-flex xs12 sm12 md6 class="text-lg-right">
                    <h3 class="mt-3 mr-2">FORMA DE PAGO:</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      v-model="pagoVenta.formaPagoId"
                      :items="formasPago"
                      item-text="descripcion"
                      item-value="formaPagoId"
                      label="Forma del pago"
                      placeholder="Forma del pago"
                      single-line
                      :rules="[
                        () =>
                          !!pagoVenta.formaPagoId || 'El campo es requerido',
                      ]"
                      required
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md6 class="text-lg-right">
                    <h3 class="mt-3 mr-2">CONCEPTO PAGO:</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      v-model="pagoVenta.conceptoPagoId"
                      :items="conceptosPago"
                      item-text="descripcion"
                      item-value="conceptoPagoId"
                      label="Concepto del pago"
                      single-line
                      :rules="[
                        () =>
                          !!pagoVenta.conceptoPagoId || 'El campo es requerido',
                      ]"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md6 class="text-lg-right">
                    <h3 class="mt-3 mr-2">MONTO DEL PAGO:</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Monto del pago"
                      v-model="pagoVenta.montoPago"
                      :rules="[
                        (v) =>
                          (!!pagoVenta.montoPago && pagoVenta.montoPago > 0) ||
                          'Debe tener un valor mayor a cero',
                      ]"
                      prefix="$"
                      type="number"
                      @input="calcularCambio"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 class="text-lg-right">
                    <h3 class="mt-3 mr-2">CAMBIO DEVUELTO:</h3>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <h3 class="red--text mt-3">
                      $ {{ formatMoney(pagoVenta.cambioDevuelto) }}
                    </h3>
                  </v-flex>

                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="pagoVenta.montoPago < totales.totalFinal"
                  >
                    <v-text-field
                      ref="comentariosVenta"
                      label="Comentarios venta"
                      v-model="venta.comentariosVenta"
                      :rules="[
                        () =>
                          !!venta.comentariosVenta || 'El campo es requerido',
                      ]"
                      type="text"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-radio-group v-model="venta.entregada" row>
                      <v-radio label="Entregada" :value="true"></v-radio>
                      <v-radio label="No entregada" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 sm12 md12 class="text-lg-right">
                    <v-btn
                      color="primary darken-4"
                      :loading="$store.state.operationInProgress"
                      @click="saveVenta"
                      >Registrar venta</v-btn
                    >
                  </v-flex>

                  <v-alert
                    :value="$store.state.operationSuccess"
                    color="success"
                    icon="check_circle"
                    transition="scale-transition"
                  >
                    <span v-html="$store.state.successMessage"></span>
                  </v-alert>

                  <v-alert
                    :value="$store.state.operationFailed"
                    color="error"
                    icon="warning"
                    transition="scale-transition"
                  >
                    <span v-html="$store.state.errorMessage"></span>
                  </v-alert>
                </v-layout>
              </div>
            </v-widget>
          </v-form>
        </v-flex>
      </v-layout>
    </template>
    <loading-alert></loading-alert>
    <snack-bar></snack-bar>
    <confirm ref="confirm"></confirm>
  </v-container>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import loadingAlert from "@/components/LoadingAlert";
import VWidget from "@/components/VWidget";
import snackBar from "@/components/SnackBar";
import confirm from "@/components/dialogs/Confirm";
import moment from "moment";

import ventaService from "@/services/ventaService";
import catalogoProductoService from "@/services/catalogoProductoService";
import conceptoPagoService from "@/services/conceptoPagoService";
import formaPagoSevice from "@/services/formaPagoService";
import clienteService from "@/services/clienteService";
import tallaService from "@/services/tallaService";

//global
import { factorIva } from "@/config";

//Local Components
import formCliente from "@/views/clientes/FormCliente";

export default {
  components: {
    VuePerfectScrollbar,
    VWidget,
    loadingAlert,
    snackBar,
    confirm,
    formCliente,
  },
  data() {
    return {
      search: "",
      searchCarrito: "",
      loadingClientes: false,
      pagination: {
        rowsPerPage: 5,
      },
      sucursalesUsuario: [],
      sucursalSeleccionada: {
        sucursalId: 0,
        nombreSucursal: "",
      },
      preciosProductos: [],
      precioProducto: {
        catalogoRowId: 0,
        sku: "",
        productoId: 0,
        descripcionProducto: "",
        tallaId: 0,
        descripcionTalla: "",
        colorId: 0,
        nombreColor: "",
        codigoHtml: "",
        precioVenta: 0,
        precioRenta: 0,
      },
      catalogoProductos: [],
      clientes: [],
      venta: {
        ventaId: 0,
        folioVenta: "",
        fechaVenta: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        subTotal: 0,
        porcentajeDescuento: 0,
        total: 0,
        iva: 0,
        totalFinal: 0,
        pagado: 0,
        cambioDevuelto: 0,
        sucursalId: 0,
        clienteId: null,
        cliente: {
          clienteId: 0,
          nombreCompletoCliente: "",
          domicilio: "",
          colonia: "",
          codigoPostal: "",
          paisId: 146,
          entidadId: null,
          municipioId: null,
          telefonoParticular: null,
          telefonoCelular: null,
          correoContacto: "",
          descuento: 0,
          municipio: {
            municipioId: 0,
            nombreMunicipio: "",
          },
          domicilioCompleto: "",
        },
        comentariosVenta: null,
        entregada: true,
        detalleVentaProductos: [],
        pagosVenta: [],
      },
      carritoVenta: {
        headers: [
          { text: "", align: "center", sortable: false },
          { text: "PRODUCTO", align: "center", value: "descripcionProducto" },
          { text: "TALLA", align: "center", value: "descripcionTalla" },
          { text: "COLOR", align: "center", value: "nombreColor" },
          { text: "P / UNITARIO", align: "center", value: "precioVenta" },
          { text: "CANTIDAD", align: "center", value: "cantidad" },
          { text: "SUBTOTAL", align: "center", value: "cantidad" },
          { text: "ELIMINAR", value: "acciones", align: "right" },
        ],
        articulos: [],
      },
      porcentajeDescuento: false,
      totales: {
        headers: [
          { text: "", align: "left", width: "30%", sortable: false },
          {
            text: "",
            align: "center",
            width: "40%",
            sortable: false,
          },
          { text: "", align: "center", width: "10%", sortable: false },
          { text: "TOTALES", align: "center", width: "20%", sortable: false },
        ],
        subtotal: 0,
        porcentajeDescuento: 0,
        montoDescuento: 0,
        subTotalDescuento: 0,
        iva: 0,
        totalFinal: 0,
      },
      formasPago: [],
      conceptosPago: [],
      pagoVenta: {
        numPago: 1,
        fechaPago: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        montoPago: 0,
        cambioDevuelto: 0,
        conceptoPagoId: 3,
        formaPagoId: 1,
      },
      clienteCombo: {
        clienteId: 0,
        codigoPostal: "",
        colonia: "",
        correoContacto: "",
        descuento: 0,
        domicilio: "",
        entidadId: 11,
        municipio: {
          municipioId: 0,
          nombreMunicipio: "",
        },
        municipioId: 0,
        nombreCompletoCliente: "",
        paisId: 146,
        sucursalId: 0,
        telefonoCelular: "",
        telefonoParticular: "",
      },
    };
  },
  mounted() {
    let self = this;
    try {
      let current_user = this.$store.state.currentUser;
      this.sucursalesUsuario = current_user.sucursales;
      if (this.sucursalesUsuario.length > 0) {
        this.sucursalSeleccionada = this.sucursalesUsuario[0];
        this.venta.sucursalId = this.sucursalSeleccionada.sucursalId;
      }
    } catch (e) {
      self.codeFailed(
        "Ocurrió un error al extraer sucursales, es posible que se haya perdido la sesión o no tengas sucursales asignadas"
      );
    }

    this.getFormasPago();
    this.getConceptosPago();
    this.getClientes();
  },
  watch: {
    sucursalSeleccionada: function (n) {
      this.venta.sucursalId = n.sucursalId;
      this.getPreciosProductos(n.sucursalId);
      this.getClientes();
    },
  },
  computed: {
    filteredItems() {
      return this.catalogoProductos.filter((item) => {
        return (
          item.descripcionProducto.toUpperCase().match(this.search) ||
          item.descripcionTalla.toUpperCase().match(this.search) ||
          item.nombreColor.toUpperCase().match(this.search) ||
          item.sku.toUpperCase().match(this.search)
        );
      });
    },
  },
  methods: {
    getPreciosProductos(sucursalId) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      catalogoProductoService
        .getPreciosProductos(sucursalId)
        .then((result) => {
          self.preciosProductos = result;
          self.catalogoProductos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getConceptosPago() {
      let self = this;
      conceptoPagoService
        .getAll()
        .then((result) => {
          self.conceptosPago = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getFormasPago() {
      let self = this;

      formaPagoSevice
        .getAll()
        .then((result) => {
          self.formasPago = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getClientes() {
      let self = this;
      self.loadingClientes = true;
      clienteService
        .getAllBySucursal(self.sucursalSeleccionada.sucursalId)
        .then((result) => {
          self.clientes = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingClientes = false;
        });
    },
    toUpper() {
      if (this.search === null) {
        this.search = "";
      } else {
        this.search = this.search.toUpperCase();
      }
    },
    addArticulo(articulo) {
      let self = this;
      var productoItem = self.carritoVenta.articulos.find(
        (obj) => obj.catalogoRowId == articulo.catalogoRowId
      );
      if (typeof productoItem === "undefined") {
        articulo.cantidad = 1;
        articulo.subTotalProducto = articulo.precioVenta * articulo.cantidad;
        self.carritoVenta.articulos.push(articulo);
        self.validarAgregadoTalla(articulo.tallaId);
        self.calcularSubtotal();
      } else {
        self.$store.state.snackbar.color = "warning";
        self.$store.state.snackbar.text = "Ya agregaste ese producto";
        self.$store.state.snackbar.visible = true;
      }
    },
    pullArticulo(catalogoRowId) {
      let self = this;
      var i = this.carritoVenta.articulos.findIndex(
        (obj) => obj.catalogoRowId == catalogoRowId
      );
      self.carritoVenta.articulos.splice(i, 1);
      self.calcularSubtotal();
    },
    calcularSubtotal() {
      let self = this;
      self.totales.subtotal = 0;
      self.carritoVenta.articulos.forEach((articulo) => {
        articulo.subTotalProducto = articulo.precioVenta * articulo.cantidad;
        self.totales.subtotal += Number(articulo.subTotalProducto);
      });
      self.calcularTotales();
    },
    calcularTotales() {
      let self = this;

      if (self.porcentajeDescuento) {
        self.totales.montoDescuento = 0;
      } else {
        self.totales.porcentajeDescuento = 0;
      }

      const factorDescuentoProductos =
        (100 - self.totales.porcentajeDescuento) / 100;
      var subtotal = Number(self.totales.subtotal);

      self.totales.subTotalDescuento = subtotal * factorDescuentoProductos;
      self.totales.subTotalDescuento =
        self.totales.subTotalDescuento - self.totales.montoDescuento;

      self.totales.iva = self.totales.subTotalDescuento * factorIva;
      self.totales.totalFinal =
        self.totales.subTotalDescuento + self.totales.iva;

      self.calcularCambio();
    },
    calcularCambio() {
      let self = this;
      let cambioDevuelto = this.pagoVenta.montoPago - this.totales.totalFinal;
      if (cambioDevuelto < 0) {
        cambioDevuelto = 0;
        self.venta.entregada = false;
        self.pagoVenta.conceptoPagoId = 1;
      } else {
        self.venta.entregada = true;
        self.pagoVenta.conceptoPagoId = 3;
      }
      this.pagoVenta.cambioDevuelto = cambioDevuelto;
    },
    setCliente(cliente) {
      let self = this;
      if (cliente === "" || typeof cliente === "undefined") {
        self.venta.clienteId = null;
        self.clienteCombo = {
          clienteId: 0,
          codigoPostal: "",
          colonia: "",
          correoContacto: "",
          descuento: 0,
          domicilio: "",
          entidadId: 11,
          municipio: {
            municipioId: 0,
            nombreMunicipio: "",
          },
          municipioId: 0,
          nombreCompletoCliente: "",
          paisId: 146,
          sucursalId: 0,
          telefonoCelular: "",
          telefonoParticular: "",
        };
        self.venta.cliente = {
          clienteId: 0,
          codigoPostal: "",
          colonia: "",
          correoContacto: "",
          descuento: 0,
          domicilio: "",
          entidadId: 11,
          municipio: {
            municipioId: 0,
            nombreMunicipio: "",
          },
          municipioId: 0,
          nombreCompletoCliente: "",
          paisId: 146,
          sucursalId: 0,
          telefonoCelular: "",
          telefonoParticular: "",
        };
      } else {
        self.venta.clienteId = cliente.clienteId;
        //self.renta.cliente = cliente;
        clienteService.get(cliente.clienteId).then((result) => {
          self.clienteCombo = result;
        });
      }
    },
    abrirDialogCliente() {
      this.$store.state.tituloForm = "ACTUALIZAR CLIENTE";
      this.$store.state.iconoForm = "/images/general/actualizar-40.png";
      this.$refs.dialogCliente.openDialog();
    },
    abrirDialogNuevoCliente() {
      this.$store.state.tituloForm = "AGREGAR CLIENTE";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogCliente.resetForm();
      this.$refs.dialogCliente.openDialog();
    },
    clearCliente() {
      let self = this;
      this.clienteCombo = {
        clienteId: 0,
        codigoPostal: "",
        colonia: null,
        correoContacto: null,
        descuento: 0,
        domicilio: null,
        entidadId: null,
        municipio: {
          municipioId: 0,
          nombreMunicipio: "",
        },
        municipioId: null,
        nombreCompletoCliente: "",
        paisId: 146,
        sucursalId: self.sucursalSeleccionada.sucursalId,
        telefonoCelular: null,
        telefonoParticular: null,
      };
      this.venta.clienteId = null;

      this.$refs.comboCliente.text = "";
    },
    onClienteAdded(cliente) {
      let self = this;
      self.clientes.push(cliente);
      self.venta.clienteId = cliente.clienteId;
      clienteService.get(cliente.clienteId).then((result) => {
        self.clienteCombo = result;
      });
    },
    onClienteUpdated(cliente) {
      let self = this;
      self.venta.clienteId = cliente.clienteId;
      clienteService.get(cliente.clienteId).then((result) => {
        self.clienteCombo = result;
      });
    },
    saveVenta() {
      let self = this;
      if (self.$refs.formVenta.validate()) {
        if (
          self.pagoVenta.montoPago < self.totales.totalFinal &&
          (self.venta.clienteId === 0 || self.venta.clienteId === null)
        ) {
          self.$store.state.snackbar.color = "error";
          self.$store.state.snackbar.text =
            "Debes seleccionar o registrar a un cliente";
          self.$store.state.snackbar.visible = true;
        } else {
          this.$refs.confirm
            .open(
              "REGISTRAR VENTA",
              "Se registrará una venta, ¿Está seguro de continuar?",
              { color: "primary" }
            )
            .then((confirm) => {
              if (confirm) {
                self.operationStart();
                self.venta.subtotal = self.totales.subtotal;
                self.venta.porcentajeDescuento =
                  self.totales.porcentajeDescuento;
                self.venta.montoDescuento = self.totales.montoDescuento;
                self.venta.total = self.totales.subTotalDescuento;
                self.venta.iva = self.totales.iva;
                self.venta.totalFinal = self.totales.totalFinal;
                self.venta.pagado = self.pagoVenta.montoPago;
                self.venta.cambioDevuelto = self.pagoVenta.cambioDevuelto;
                self.venta.detalleVentaProductos.length = 0;
                self.venta.pagosVenta.length = 0;

                //Detalle producto -Adicionales
                self.carritoVenta.articulos.forEach((p) => {
                  self.venta.detalleVentaProductos.push({
                    ventaId: self.venta.ventaId,
                    catalogoRowId: p.catalogoRowId,
                    precioUnitario: p.precioVenta,
                    cantidad: p.cantidad,
                    subtotal: p.subTotalProducto,
                    esConjunto: false,
                  });
                });

                //Pago venta
                self.venta.pagosVenta.push({
                  ventaId: self.venta.ventaId,
                  numPago: self.pagoVenta.numPago,
                  fechaPago: self.pagoVenta.fechaPago,
                  montoPago: self.pagoVenta.montoPago,
                  conceptoPagoId: self.pagoVenta.conceptoPagoId,
                  formaPagoId: self.pagoVenta.formaPagoId,
                  cambioDevuelto: self.pagoVenta.cambioDevuelto,
                });
                ventaService
                  .add(self.venta)
                  .then((result) => {
                    self.operationSuccess();
                    self.$store.state.successMessage =
                      "Venta registrada con éxito";
                    self.descargarTicketVenta(result.ventaId);
                    setTimeout(() => {
                      self.resetForm();
                      self.verificarCorteCaja();
                    }, 1500);
                  })
                  .catch((e) => {
                    self.operationFailed(e);
                    console.log(e);
                  });
              } else {
                self.$store.state.snackbar.color = "error";
                self.$store.state.snackbar.text = "Operación cancelada";
                self.$store.state.snackbar.visible = true;
              }
            });
        }
      }
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formVenta.resetValidation();
      self.venta.ventaId = 0;
      self.venta.folioVenta = "";
      self.venta.fechaVenta = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      self.venta.subTotal = 0;
      self.venta.porcentajeDescuento = 0;
      self.venta.total = 0;
      self.venta.iva = 0;
      self.venta.totalFinal = 0;
      self.venta.pagado = 0;
      self.venta.entregada = true;
      self.venta.detalleVentaProductos = [];
      self.venta.pagosVenta = [];

      self.carritoVenta.articulos = [];

      self.totales.subtotal = 0;
      self.totales.porcentajeDescuento = 0;
      self.totales.montoDescuento = 0;
      self.totales.subTotalDescuento = 0;
      self.totales.iva = 0;
      self.totales.totalFinal = 0;
      self.clearCliente();
      self.pagoVenta = {
        numPago: 1,
        montoPago: 0,
        fechaPago: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        conceptoPagoId: 3,
        cambioDevuelto: 0,
        formaPagoId: 1,
      };
    },
    descargarTicketVenta(id) {
      var h = 900;
      var w = 400;
      var left = screen.width / 2 - w / 2;
      var top = 5;
      var titulo = "VISUALIZACIÓN DEL DOCUMENTO";

      let self = this;
      self.showCargando = true;
      ventaService
        .getTicketVenta(id)
        .then((result) => {
          var byteCharacters = atob(result);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/pdf;base64" });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          var newwindow = window.open(
            fileURL,
            titulo,
            "height=" + h + ",width=" + w + ", top=" + top + ", left=" + left
          );

          if (window.focus) {
            newwindow.focus();
            newwindow.print();
          }
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.showCargando = false;
        });
    },
    async validarAgregadoTalla(tallaId) {
      let self = this;
      let talla = await tallaService.get(tallaId);

      if (talla.catalogoRowIdAgregado) {
        // let catalogoDetalle = await catalogoProductoService.get(
        //   talla.catalogoRowIdAgregado
        // );

        let catalogoProductoItem = self.catalogoProductos.find(
          (c) => c.catalogoRowId == talla.catalogoRowIdAgregado
        );
        self.addArticulo(catalogoProductoItem);
      }
    },
  },
};
</script>

<style>
.v-btn-30 {
  height: 25px !important;
  width: 25px !important;
}
</style>
